module.exports = __webpack_public_path__ + "static/media/more-horizontal.79e0aded.svg";